<template>
    <div id="globe-button">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
            <path d="M0.360352 10.2349V11.4819C0.372304 11.5552 0.386647 11.628 0.395811 11.7017C0.443023 12.085 0.470912 12.4735 0.538444 12.8532C0.915346 14.9725 1.81457 16.7996 3.23612 18.3345C4.72361 19.9398 6.51071 20.9504 8.59862 21.3353C8.97353 21.4043 9.35322 21.4451 9.73072 21.499H10.8973C10.9539 21.4871 11.01 21.4735 11.0668 21.463C11.6973 21.3482 12.3417 21.2882 12.9559 21.1112C17.9393 19.6757 21.075 14.284 20.0939 8.87024C19.6776 6.57414 18.675 4.61664 17.0592 3.04395C14.754 0.80002 12.03 -0.0948277 8.94325 0.324272C6.97726 0.591108 5.24494 1.45295 3.75964 2.85612C2.0098 4.50782 0.915745 6.56306 0.513344 9.0274C0.448003 9.42734 0.410552 9.83238 0.360352 10.2349ZM6.36409 14.868C6.11883 13.7614 5.98144 12.6307 5.95412 11.4939H9.71916V14.6188L6.36409 14.868ZM14.6751 11.4932C14.6491 12.6212 14.5128 13.7432 14.2685 14.8409L10.9084 14.6139V11.4932H14.6751ZM1.51955 11.4949H4.7268C4.86997 12.7017 5.01087 13.8894 5.14952 15.0579C4.42699 15.2496 3.68614 15.4412 2.94926 15.647C2.81639 15.6842 2.75822 15.664 2.69029 15.5369C2.28192 14.7681 1.96577 13.9593 1.78409 13.0977C1.67473 12.5748 1.60839 12.0416 1.51955 11.4949ZM15.8978 10.224C15.755 9.04103 15.6145 7.87893 15.4743 6.71661L17.8945 6.10819C18.5861 7.36139 18.9905 8.77176 19.0746 10.224H15.8978ZM17.8957 15.6037L15.4843 15.0287C15.6228 13.8519 15.7611 12.6758 15.8992 11.5003H19.0758C18.9788 12.9836 18.5855 14.3514 17.8957 15.6037ZM10.9072 7.16147L14.2627 6.91466C14.5035 7.99779 14.6411 9.10421 14.6735 10.217H10.9072V7.16147ZM6.3617 6.93936L9.71916 7.16339V10.2215H5.95273C5.99257 9.10109 6.11767 8.00798 6.3617 6.93936ZM1.57154 10.2227C1.56532 10.201 1.56138 10.1785 1.55979 10.1559C1.64764 8.76078 2.02115 7.45706 2.66738 6.24342C2.69229 6.19678 2.80683 6.17165 2.87058 6.18656C3.48812 6.33328 4.10348 6.49236 4.72023 6.64377C4.87422 6.68168 5.03139 6.70511 5.14992 6.72789C5.00848 7.91023 4.87103 9.05871 4.73158 10.2227H1.57154ZM10.9124 20.1497V15.8727L13.9424 16.0676C13.8462 16.3393 13.7756 16.5618 13.6898 16.7776C13.328 17.6867 12.8941 18.5491 12.2356 19.2596C11.8628 19.6616 11.4435 19.9885 10.9124 20.1497ZM9.71916 1.63545V5.90567L6.71112 5.71401C6.91172 4.81043 7.65775 3.3702 8.26972 2.66872C8.67192 2.20617 9.12433 1.82754 9.71916 1.63545ZM9.71916 20.1489C9.32254 20.0356 8.99345 19.8222 8.69424 19.5526C7.85756 18.8017 7.35058 17.8117 6.93303 16.7584C6.85116 16.5516 6.78283 16.3384 6.69518 16.0912L9.71916 15.8774V20.1489ZM10.9104 5.90205V1.6067C12.633 2.37335 13.2973 3.98458 13.9428 5.68994L10.9104 5.90205ZM3.42418 5.07322C4.00905 4.02973 6.42565 2.13441 7.14001 2.15315C6.3884 3.16299 5.89596 4.30721 5.50969 5.53917L3.42418 5.07322ZM13.5041 2.13441C14.9705 2.72324 16.1759 3.68367 17.1913 5.01827L15.107 5.50807C14.7247 4.28016 14.2265 3.15 13.5041 2.13441ZM17.1919 16.7007C16.1871 18.021 14.9958 18.9751 13.5754 19.582C13.8701 19.0496 14.189 18.5349 14.4482 17.9878C14.7097 17.4354 14.9123 16.851 15.1544 16.2464L17.1919 16.7007ZM7.07368 19.5715C5.65093 18.981 4.47082 18.0453 3.47776 16.7558L5.52124 16.2767C5.88958 17.4818 6.38262 18.5775 7.07368 19.5715Z" fill="#25AD34"/>
          </svg>
    </div>
</template>

<script>
export default {
    
}
</script>

<style scoped>
#globe-button{
display: flex;
width: 41px;
height: 41px;
align-items: center;
flex-shrink: 0;
border-radius: 37px;
border: 1px solid #25AD34;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
float:left;
}

@media only screen and (max-width:480px){
    #globe-button svg{
        margin-left:9.5px;
    }
}
@media only screen and (min-width:481px) and (max-width:960px){
    #globe-button svg{
        margin-left:8.5px;
    }
}
@media only screen and (min-width:961px){
   #globe-button{
    cursor: pointer;
    
   }
   #globe-button svg{
    margin-left:10px;
}
}
</style>